import request from '@/utils/request'

const userApi = {
  login: '/certified/v1/login',
  getkaptcha: '/certified/v1/getkaptcha',
  getResetPasswordVeriCode: '/certified/v1/getResetPasswordVeriCode',
  resetCloudPassword: '/certified/v1/resetCloudPassword',
}

export function login(params) {
  console.log('login', params)
  return request({
    url: userApi.login,
    method: 'post',
    data: params
  })
}

export function getKaptchaImg(params) {
  console.log('getKaptchaImg', params)
  return request({
    url: userApi.getkaptcha,
    method: 'post',
    data: params
  })
}

export function logout() {
  console.log('logout')
  return request({
    url: 'auth/logout',
    method: 'delete'
  })
}

export function getVeriCode(params) {
  console.log('getVeriCode', params)
  return request({
    url: userApi.getResetPasswordVeriCode,
    method: 'post',
    data: params
  })
}

export function reset(params) {
  console.log('reset', params)
  return request({
    url: userApi.resetCloudPassword,
    method: 'post',
    data: params
  })
}
